import {
  Container,
  IconSeller,
  Select,
  spacing2,
} from '@leaftrade/leaftrade-component-library';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useStorefrontState } from '../../../hooks/useReduxState';
import { setSelectedQuickOrderLocations } from '../../../store/actions/storefrontActions';

const toSelectedOption = ({ label, original, value }) => ({
  label,
  original,
  value,
});

const QuickOrderLocationSelect = () => {
  const dispatch = useDispatch();
  const { quickOrderData, shopper } = useStorefrontState();
  const { selectedLocations } = quickOrderData;
  const { locations } = shopper;
  const selectedLocationCount = selectedLocations.length;
  const allLocationsSelected = selectedLocationCount === locations.length;
  const selectedLocationLabel =
    selectedLocationCount === 1 ? 'Location' : 'Locations';

  const placeholder = allLocationsSelected
    ? 'All Locations'
    : `${selectedLocationCount} ${selectedLocationLabel}`;

  const handleAllToggle = () => {
    if (!allLocationsSelected) {
      dispatch(setSelectedQuickOrderLocations(locations));
    }
  };

  const selectOptions = locations.map((location) => ({
    key: location.id,
    label: location.name,
    level: 1,
    original: location,
    selected: Boolean(
      selectedLocations.find(
        (selectedLocation) => selectedLocation.id === location.id
      )
    ),
    value: location.id,
  }));

  const selectedSelectOptions = selectOptions
    .filter((option) => option.selected)
    .map(toSelectedOption);

  const handleSelect = (selection, { setSelectedOptions }) => {
    const isSelected = selectedLocations.some(
      (selectedLocation) => selectedLocation.id === selection.value
    );

    if (isSelected && selectedLocationCount === 1) {
      setSelectedOptions(selectedSelectOptions);
      return;
    }

    const nextSelectedLocations = isSelected
      ? selectedLocations.filter(
          (selectedLocation) => selectedLocation.id !== selection.value
        )
      : [...selectedLocations, selection.original];

    setSelectedOptions(
      selectOptions
        .filter((option) =>
          nextSelectedLocations.some(
            (selectedLocation) => selectedLocation.id === option.value
          )
        )
        .map(toSelectedOption)
    );
    dispatch(setSelectedQuickOrderLocations(nextSelectedLocations));
  };

  return (
    <Select
      hasClose
      handleSelect={handleSelect}
      isPlaceholderAlwaysVisible
      label='Shopping For'
      multiSelect
      options={selectOptions}
      placeholder={
        <Container sx={{ gap: spacing2, alignItems: 'center' }}>
          <IconSeller width={16} height={16} />
          {placeholder}
        </Container>
      }
      selectAll={handleAllToggle}
      showClearAll={false}
      showFooter
      size='small'
      testingId='quick-order-location-select--component--select'
      title='Locations'
    />
  );
};

export default QuickOrderLocationSelect;
